var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationPack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13362_756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint0_linear_13362_756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 8.83317C14.6663 11.7458 11.4353 14.7791 10.3503 15.7159C10.2492 15.7919 10.1261 15.833 9.99967 15.833C9.87321 15.833 9.75017 15.7919 9.64909 15.7159C8.56409 14.7791 5.33301 11.7458 5.33301 8.83317C5.33301 7.59549 5.82467 6.40851 6.69984 5.53334C7.57501 4.65817 8.762 4.1665 9.99967 4.1665C11.2374 4.1665 12.4243 4.65817 13.2995 5.53334C14.1747 6.40851 14.6663 7.59549 14.6663 8.83317Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5835C10.9665 10.5835 11.75 9.79999 11.75 8.8335C11.75 7.867 10.9665 7.0835 10 7.0835C9.0335 7.0835 8.25 7.867 8.25 8.8335C8.25 9.79999 9.0335 10.5835 10 10.5835Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13362_756",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2430"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13362_756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationPack);
export default __webpack_public_path__ + "static/media/navigation-pack.9b1566ff8ad2da51f3abe0eae7ba5c2f.svg";
export { ForwardRef as ReactComponent };